import React from 'react';
import { providers } from 'helpers/constants';
import classnames from 'classnames';
import styles from './OAuthButton.module.scss';

interface OAuthButtonProps extends TestProps {
  type: Provider;
  onClick: () => void;
  disabled?: any;
}

export const OAuthButton: React.FC<OAuthButtonProps> = ({ type, onClick, disabled, ...props }) => {
  const provider = providers[type];

  return (
    <button
      className={classnames(classnames(styles.button, styles[`type-${provider.id}`]), {
        [styles.button]: true,
        [styles.disabled]: disabled,
      })}
      data-tid={props.tid}
      onClick={onClick}
    >
      <div className={styles.iconBox}>
        <img src={provider.imagePath} alt={`Sign in using ${provider.name}`} />
      </div>
      Sign In with {provider.name}
    </button>
  );
};
